import {
  Button,
  CircularProgress,
  ClickAwayListener,
  Grow,
  Paper,
  Popper,
} from "@mui/material";
import { useGetNotifications } from "api/queries/notificaitons";
import React from "react";
import styles from "./Header.module.css";
import { formatDistanceToNow } from "date-fns";
import {
  useReadAllNotification,
  useReadSingleNotification,
} from "api/mutations/notification/Notification";
import InfoIcon from "component/infoIcon/InfoIcon";
import { useNavigate } from "react-router-dom";
import EmptyState from "component/emptyState/EmptyState";

const Notifications = ({ anchorRef, handleClose, open, handleListKeyDown }) => {
  const { data } = useGetNotifications();
  const { readAll, loading } = useReadAllNotification();
  const { readSingle, loading: isLoading } = useReadSingleNotification();
  const navigate = useNavigate();

  const handleGotoPage = (notification) => {
    readSingle(notification);
    if (notification.action) {
      navigate(`/applications`);
      handleClose()
    }
  };
  return (
    <Popper
      open={open}
      anchorEl={anchorRef.current}
      role={undefined}
      placement="bottom-start"
      transition
      disablePortal
      style={{ zIndex: 3, position: "absolute", right: 0, top: "80px" }}
    >
      {({ TransitionProps, placement }) => (
        <Grow
          {...TransitionProps}
          style={{
            transformOrigin:
              placement === "bottom-start" ? "left top" : "left bottom",
          }}
        >
          <Paper className={styles.notifications_card}>
            <ClickAwayListener onClickAway={handleClose}>
              <div className={styles.notifications}>
                <div className={styles.notifications_header}>
                  <h3>Notifications</h3>
                  {data?.data?.data?.length > 0 && (
                    <div className={styles.mark_as_read}>
                      <Button
                        onClick={() => {
                          readAll();
                        }}
                        className={styles.read_all}
                      >
                        Mark all as read
                      </Button>
                      {loading && <CircularProgress size={20} />}
                    </div>
                  )}
                </div>

                {data?.data?.data?.map((notification) => (
                  <div
                    onClick={() => {
                      handleGotoPage(notification);
                    }}
                    style={{
                      padding: "0px 33px",
                      borderBottom: '1px solid #f3f3f3',
                      cursor: notification.action && "pointer",
                    }}
                    key={notification.id}
                  >
                    <div className={styles.notification}>
                      <InfoIcon height={"25px"} width={"25px"} />
                      <div className={styles.notification_details}>
                        <div className={styles.flex_between}>
                          <h4>{notification.subject}</h4>
                          <span>
                            {formatDistanceToNow(
                              new Date(notification.createdAt)
                            )}
                          </span>
                        </div>

                        <div className={styles.flex_between}>
                          <p>{notification.message}</p>
                          {notification.read ? null : (
                            <div className={styles.dot}></div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
                {data?.data?.data?.length === 0 && (
                  <div className={styles.empty}>
                    <EmptyState text="No notifications for you now, check back later." />
                  </div>
                )}
              </div>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  );
};

export default Notifications;